import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const SelfAssessmentDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsSelfAssessmentDetails" */ 'modules/activityDetails/SelfAssessmentDetails/pages/SelfAssessmentDetails'
    )
)

const SelfAssessmentDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route
        exact
        path={`${routes.root}/:competenceId/:assessmentId`}
        component={SelfAssessmentDetails}
      />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default SelfAssessmentDetailsRouting
